import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import axiosInstance, { handleApiError } from "../../services/axiosService";
import { toastSuccess } from "../../utils/toastUtils";
// import { useModalContext } from "../../context/ModalContext";
import { useTreeContext } from "../../context/TreeDataContext";
import ButtonActionIcon from "./ButtonActionIcon";
import Input from "../FormComponents/Input";
import Button from "../FormComponents/Button";

const FormEditAndAddControl = ({ formIsThere, activityId, smId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  // const { getUserConfirmationForDelete } = useModalContext();
  const { setFormsExplorerData } = useTreeContext();

  const { appId, orgId } = useParams();
  const addForm = async (formName, isMultipleSection) => {
    try {
      if (formName.trim().length < 3) {
        handleApiError("Form name should be more than 2 characters");
        return;
      }
      const initialFormData = {
        name: formName,
        sections: [
          {
            fields: [],
            key: "Section_123",
            progress_bar_title: "S1",
            name: "Section 1"
          }
        ],
        settings: {
          isMultiple: isMultipleSection,
          progress_bar: true,
          progress_bar_clickable: true,
          progress_bar_color_codes: {
            empty: "#808080",
            filled_valid: "#4FB32C",
            filled_invalid: "#E83429",
            filled_incomplete: "#F9D949"
          }
        },
        master_data: {}
      };

      const { message } = await axiosInstance.post(
        `/state-machine/${smId}/activity/${activityId}/form`,
        initialFormData
      );
      setIsModalOpen(false);
      setFormsExplorerData(false);
      navigate(`../../${appId}/form/${activityId}`);
      toastSuccess(message);
    } catch (error) {
      handleApiError(error);
    }
  };
  const openForm = () => {
    // http://localhost:3000/organization/659cd75c2ffce5396149b320/app/670e4bcef919919853143aaa/smform/65e1b3861a2613c579a58327/form/65e1b44d1a2613c579a584b5
    // navigate(`../../${appId}/form/${activityId}`);
    navigate(`/organization/${orgId}/app/${appId}/smform/${smId}/form/${activityId}`);
  };

  return (
    <>
      {formIsThere ? (
        <div className="form_edit_del_buttons">
          <ButtonActionIcon type="edit" size="md" onClick={openForm} />
          {/* <ButtonActionIcon type="delete" size="md" onClick={deleteActivityForm} /> */}
        </div>
      ) : (
        <div>
          <Button onClick={() => setIsModalOpen(true)} variant="secondary">
            + Create form
          </Button>
        </div>
      )}
      <BuilderModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} modalName="Add Form">
        <AddFormModal addForm={addForm} />
      </BuilderModal>
    </>
  );
};
const AddFormModal = ({ addForm }) => {
  const [formName, setFormName] = useState("");
  const [isMultipleSection, setIsMultipleSection] = useState(false);
  return (
    <div>
      <div className="builder_form">
        <div className="builder_form">
          <Input
            type="text"
            placeholder="Enter Form Name"
            label="Enter Form Name"
            value={formName}
            onChange={(e) => setFormName(e.target.value)}
          />
          <div className="builder_checkbox_outer">
            <Input
              type="checkbox"
              checked={isMultipleSection}
              onChange={(e) => setIsMultipleSection(e.target.checked)}
            />
            <label htmlFor="org_name" className="checkbox_label">
              Want multiple sections ?
            </label>
          </div>

          <Button onClick={() => addForm(formName, isMultipleSection)}>+ Add Form</Button>
        </div>
      </div>
    </div>
  );
};
export default FormEditAndAddControl;
